import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Spin,
  Button,
  Modal,
  Tabs,
  Select,
  Table,
  Tooltip as TooltipAnd,
} from "antd";
import * as util from "../Helpers/Util";
import history from "../../history";
import queryString, { parse } from "query-string";

import getBelgeTuruLists from "../../services/belgeTuruLists";
import basvuruOlustur from "../../services/basvuruOlustur";
import iskanParentBasvuruOlustur from "../../services/iskanParentBasvuruOlustur";
import sessionIleSicilSorgula from "../../services/sessionIleSicilSorgula";
import emlakBeyanSorgula from "../../services/emlakBeyanSorgula";
import parselSorgula from "../../services/parselSorgula";

const { Option } = Select;
const parsed = queryString.parse(history.location.search);

const EmlakBeyanForm = () => {
  const [spining, setSpining] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [belgeTurus, setBelgeTurus] = useState([]);
  const [emlakBeyanList, setEmlakBeyanList] = useState([]);
  const [sicilOrBeyan, setSicilOrBeyan] = useState("");

  const belgeGrubuId = 19;

  const load = async () => {
    setSpining(true);

    await getBelgeTuruLists([belgeGrubuId])
      .then((res) => {
        setBelgeTurus(res.data.result);
      })
      .catch((ex) => {
        util.errorMessage(String(ex.message));
      });

    await sessionIleSicilSorgula()
      .then(async (resp) => {
        if (resp.data.success) {
          await emlakBeyanSorgula(resp.data.result.muhatapId)
            .then((resp) => {
              if (resp.data.success) {
                setEmlakBeyanList(resp.data.result);
              } else {
                setSicilOrBeyan("beyan");
                showModal();
              }
            })
            .catch((ex) => {
              util.errorMessage(String(ex.message));
            });
        } else {
          setSicilOrBeyan("sicil");
          showModal();
        }
      })
      .catch((ex) => {
        util.errorMessage(String(ex.message));
      });
    setSpining(false);
  };

  useEffect(() => {
    load();
  }, []);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    if (sicilOrBeyan == "sicil") {
      window.parent.close();
      window.open("https://ebelediye.bcekmece.bel.tr/Sicil/Index", "_blank");
    } else {
      window.open(
        "https://ebelediye.bcekmece.bel.tr/Giris/Index/?returnURL=/Beyan/EmlakBeyanOlustur/",
        "_blank"
      );
    }

    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const columns = [
    {
      title: "Beyan Sıra",
      dataIndex: "beyanSira",
      width: "10%",
      editable: true,
    },
    {
      title: "Beyan No",
      dataIndex: "beyanNo",
      width: "10%",
      editable: true,
    },
    {
      title: "Mahalle Adı",
      dataIndex: "mahalleAdi",
      width: "15%",
      editable: true,
    },
    {
      title: "Sokak Adı",
      dataIndex: "sokakAdi",
      width: "20%",
      editable: true,
    },
    {
      title: "Ada",
      dataIndex: "adaAdi",
      width: "10%",
      editable: true,
    },
    {
      title: "Parsel",
      dataIndex: "parselAdi",
      width: "10%",
      editable: true,
    },
    {
      title: "Kapı",
      dataIndex: "kapi",
      width: "10%",
      editable: true,
    },
    {
      title: "Blok",
      dataIndex: "blok",
      width: "10%",
      editable: true,
    },
    {
      title: "Daire",
      dataIndex: "daire",
      width: "10%",
      editable: true,
    },
    {
      title: "Belge Türü",
      key: "belgeTuruId",
      width: "15%",
      dataIndex: "BELGETURU",
      render: (text, record) => (
        <Select
          style={{ width: 200 }}
          showSearch
          allowClear
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
          placeholder="Belge turu"
          onChange={(value) => onChange(value, "belgeTuruId", record)}
        >
          {belgeTurus &&
            belgeTurus.map((bt) => (
              <Option key={bt.objectid} value={bt.objectid}>
                {bt.adi}
              </Option>
            ))}
        </Select>
      ),
    },
    {
      title: "Başvuru Kaydet",
      key: "key",
      dataIndex: "key",
      width: "25%",
      render: (text, record) => (
        <TooltipAnd title="Başvuru Kaydet">
          <Button
            type="primary"
            onClick={async () => {
              setSpining(true);
              await basvuruOnFinish(record);
              setSpining(false);
            }}
            style={{ marginTop: 5 }}
            loading={spining}
          >
            Başvuru Kaydet
          </Button>
        </TooltipAnd>
      ),
    },
  ];

  function onChange(value, key, record) {
    record[key] = value;
    console.log("changed", value);
  }
  const getParsel = async (ada, parsel, misId) => {
    let parselSorgu;
    await parselSorgula({ ada: ada, parsel: parsel, misId: misId })
      .then(async (res) => {
        parselSorgu = res.data.result;
        if (parselSorgu == null)
          util.errorMessage(
            "İlgili ada/parsel ve mahalle bilgisine göre parsel kaydı bulunamadı."
          );
      })
      .catch((ex) => {
        util.errorMessage(String(ex.message));
      });
    return parselSorgu;
  };

  const basvuruOnFinish = async (values) => {
    if (values.belgeTuruId != undefined) {
      let parsel = await getParsel(
        values.adaAdi,
        values.parselAdi,
        values.idAbsMahalle
      );
      if (parsel != null) {
        let parentBasvuruFilter = {
          BelgeTuruId: values.belgeTuruId,
          BelgeGrubuId: belgeGrubuId,
          GeoMahalleId: parsel.idariMahalleId,
          ParselId: parsel.objectId,
          YapiDenetimVarMi: 0,
          BeyanNo: values.beyanNo,
        };

        await iskanParentBasvuruOlustur(parentBasvuruFilter)
          .then(async (resp) => {
            if (resp.data.success) {
              let basvuruFilter = {
                altSurecTipiId: parseInt(parsed["altSurecTipiId"]),
                parentObjectId: resp.data.result.objectid,
                basvuranTipiId: 1, //BasvuranTuru.Kendi
                multipleBasvuru: true,
              };

              await basvuruOlustur(basvuruFilter)
                .then((basvuruResp) => {
                  if (basvuruResp.data.success) {
                    var result = basvuruResp.data.result;
                    window.location.replace(
                      window.location.origin +
                        "/belnet/genericclass/GenelBFormu.aspx?&KODU=" +
                        result.BasvuruId +
                        "&BFORM=" +
                        result.BasvuruFormUrl +
                        "&belge_turu_id=" +
                        result.BelgeTuruId +
                        "&alt_surec_tipi_id=" +
                        result.AltSurecTipiId +
                        "&parent_objectid=" +
                        result.ParentBasvuruId +
                        "&nomaster=true"
                    );
                  } else {
                    util.errorMessage(basvuruResp.data.message);
                  }
                })
                .catch((ex) => {
                  util.errorMessage(String(ex.message));
                });
            } else {
              util.errorMessage(resp.data.message);
            }
          })
          .catch((ex) => {
            util.errorMessage(String(ex.message));
          });
      }
    } else util.errorMessage("Belge türü seçilmesi zorunludur.");
  };
  return (
    <>
      <Spin tip={"Veriler yükleniyor/sorgulanıyor..."} spinning={spining}>
        <Card
          style={{ margin: "20px" }}
          title={
            <h4 style={{ fontWeight: "bolder", color: "white" }}>
              Emlak Beyan Listesi
            </h4>
          }
          className="ant-card-head-title-large"
        >
          <Row gutter={16}>
            <Col span={24}>
              {emlakBeyanList.length > 0 && (
                <Table
                  scroll={{}}
                  pagination={false}
                  rowKey={"beyanNo"}
                  bordered
                  dataSource={emlakBeyanList}
                  columns={columns}
                  title={() => (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h3 style={{ fontWeight: "bolder" }}>{""}</h3>
                    </div>
                  )}
                />
              )}
            </Col>
          </Row>
          <Modal
            visible={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            okText={
              sicilOrBeyan == "sicil" ? "Sicil Oluştur" : "Emlak Beyanı Oluştur"
            }
            cancelText="İptal"
          >
            {sicilOrBeyan == "sicil" ? (
              <p>Sicil kaydı bulunamadı. Sicil oluşturmanız gerekmektedir.</p>
            ) : (
              <p>
                Emlak beyan kaydı bulunamadı. Emlak beyan başvurusunda
                bulunmanız gerekmektedir.
              </p>
            )}
          </Modal>
        </Card>
      </Spin>
    </>
  );
};

export default EmlakBeyanForm;
